import { useQuery } from 'react-query'
import { shouldRetry } from '../../shared/retry'
import type { AvatarBoClient } from '../../shared/types'

export const avatarBoKeys = {
  sets: () => ['avatar-bo', 'sets'] as const,
  catalogue: (setId: string) => ['avatar-bo', 'catalog', setId] as const,
}

export interface UseAvatarCatalogueOpts {
  client: AvatarBoClient
  setId?: string
  enabled?: boolean
}

export function useAvatarCatalogue({
  client,
  setId,
  enabled = true,
}: UseAvatarCatalogueOpts) {
  const sets = useQuery(avatarBoKeys.sets(), () => client.listSets(), {
    enabled,
    refetchOnWindowFocus: false,
    retry: shouldRetry,
  })

  const catalogue = useQuery(
    avatarBoKeys.catalogue(setId ?? ''),
    () => client.getCatalogue(setId as string),
    {
      enabled: enabled && Boolean(setId),
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
  )

  return { sets, catalogue }
}
